import {Component, Input, ViewChild} from '@angular/core';
import {Button} from '../base-interaction-buttons.component';
import {SwiperComponent, SwiperConfigInterface} from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-swiper-interaction-buttons',
  templateUrl: './swiper-interaction-buttons.component.html',
  styleUrls: ['./swiper-interaction-buttons.component.scss']
})
export class SwiperInteractionButtonsComponent {
  @ViewChild('swiperRef', {read: SwiperComponent}) swiperRef: SwiperComponent;
  @Input() buttons: Array<Button>;
  @Input() activeFormId: string;
  swiperConfig: SwiperConfigInterface = {
    a11y: true,
    direction: 'horizontal',
    keyboard: true,
    mousewheel: true,
    scrollbar: false,
    navigation: false,
    pagination: false,
    spaceBetween: 8,
  };

  constructor() {
  }
}
